import React from "react";
import InductionSearch from "./InductionSearch";

function DivisionSearch() {
  return <InductionSearch isDivision />;
}

export default DivisionSearch;
